import {action} from 'typesafe-actions';
import {ServiceProvider, ServiceProvidersActionTypes} from './types';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const fetchServiceProviderRequest = (serviceProviderId: string) =>
  action(ServiceProvidersActionTypes.FETCH_SERVICE_PROVIDER_REQUEST, serviceProviderId);
export const fetchServiceProviderSuccess = (serviceProvider: ServiceProvider) =>
  action(ServiceProvidersActionTypes.FETCH_SERVICE_PROVIDER_SUCCESS, serviceProvider);
